<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/137W23H/tc-custom/9781631940200.jpg?1708804230025" alt="This image is the cover for the book False Scent, Roderick Alleyn"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">False Scent, Roderick Alleyn
      </h1>
      <p class="bookDescription body article font2">
        <b>This tale of an actress’s dramatic demise, and a police detective trying to sniff out a killer, is “one of Ngaio Marsh's best yarns” (<i>Kirkus Reviews</i>).</b><br/><br/> Mary Bellamy is the sweetheart of the London stage—everyone simply adores darling Mary. So her fans and friends are heartbroken when somehow Mary manages to spritz herself not with her favorite perfume but with a deadly insecticide meant to be sprayed on the azaleas. What Inspector Alleyn smells is something fishy, especially since everything he learns about lovely, fragile Mary suggests that in fact she was a rather vicious battleax. And with a bit more investigation, he quickly starts smelling something different: a rat . . .<br/><br/> “It’s time to start comparing Christie to Marsh instead of the other way around.” —<i>New York Magazine</i><br/><br/> “[Her] writing style and vivid characters and settings made her a mystery novelist of world renown.” —<i>The New York Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ngaio Marsh
      </h2>
      
      <p class="authorDescription body article">Ngaio Marsh (1895-1982) was one of the celebrated queens of the Golden Age of detective fiction; born in New Zealand, she wrote 32 novels in the &quot;Inspector Alleyn&quot; series.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Felony & Mayhem Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?db18cc6c